import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const pollsApi = createApi({
  reducerPath: 'pollsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    savePollResponses: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: `${urls.responseCollections}/${req.id}`,
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: `${urls.responseCollections}`,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    getPollResponses: builder.query({
      query: (id) => ({
        url: id
          ? `${urls.responseCollections}/${id}`
          : urls.responseCollections,
      }),
    }),
    getTeachingStaffResponses: builder.query({
      query: (includeExternal) => ({
        url: urls.responseCollectionsTeachingStaff,
        params: { include_external: includeExternal ? 1 : 0 },
      }),
      transformResponse: (response) => response.data,
    }),
    getSubjectResponses: builder.query({
      query: (includePhd) => ({
        url: urls.responseCollectionsSubjects,
        params: { include_phd: includePhd ? 1 : 0 },
      }),
      transformResponse: (response) => response.data,
    }),
    setResponseCollectionActive: builder.mutation({
      query: ({ id, isActive }) => ({
        url: urls.responseCollectionActive(id),
        method: 'PUT',
        data: { is_active: isActive },
      }),
    }),
    getPollResponsesMapped: builder.query({
      query: () => ({
        url: urls.responseCollectionsMapped,
      }),
    }),
    deletePollResponses: builder.mutation({
      query(id) {
        return {
          url: `${urls.responseCollections}/${id}`,
          method: 'DELETE',
        };
      },
    }),
    getPolls: builder.query({
      query: () => ({
        url: urls.polls,
      }),
    }),
    getPoll: builder.query({
      query: (id) => ({
        url: id ? urls.pollDetail(id) : null, // id or slug
      }),
    }),
    savePoll: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.pollDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.polls,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    saveResultsPublic: builder.mutation({
      query(req) {
        return {
          url: urls.pollResultToPublic(req.id),
          method: 'PUT',
          data: { show_results: req.checked },
        };
      },
    }),
    deletePoll: builder.mutation({
      query(id) {
        return {
          url: `${urls.polls}/${id}`,
          method: 'DELETE',
        };
      },
    }),
    getPollResults: builder.query({
      query: (id) => ({
        url: urls.pollResults(id),
      }),
    }),
    voteInPoll: builder.mutation({
      query(req) {
        return {
          url: urls.votePoll,
          method: 'POST',
          data: req.body,
        };
      },
    }),
    activateDeactivatePoll: builder.mutation({
      query(req) {
        return {
          url: urls.activateDeactivatePoll,
          method: 'POST',
          data: req,
        };
      },
    }),
  }),
});

export const {
  useSavePollResponsesMutation,
  useGetPollResponsesQuery,
  useDeletePollResponsesMutation,
  useGetPollsQuery,
  useDeletePollMutation,
  useGetPollResultsQuery,
  useSavePollMutation,
  useSaveResultsPublicMutation,
  useGetPollQuery,
  useGetPollResponsesMappedQuery,
  useLazyGetTeachingStaffResponsesQuery,
  useLazyGetSubjectResponsesQuery,
  useSetResponseCollectionActiveMutation,
  useVoteInPollMutation,
  useActivateDeactivatePollMutation,
} = pollsApi;
